<template>
  <video preload="auto"
         ref="video"
         playsinline
         class="w-full h-auto border-2 border-white rounded shadow-lg t3m-ImageMap-video md:rounded-lg"
         :src="`${backgroundUrl}#t=0.001`"
         muted
         @timeupdate="track"></video>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "t3mVideo",
  // props: {
  //   url: {
  //     type: String
  //   }
  // },
  computed: {
    ...mapState(["backgroundUrl", "status", "selectedHotspot"])
  },
  mounted() {
    this.$refs.video.classList.add("mounted");
  },
  methods: {
    ...mapActions(["setStatus", "reset"]),
    track: function (e) {
      if (typeof this.selectedHotspot == undefined) {
        return;
      }

      switch (this.status) {
        case "idle":
          this.$refs.video.pause();
          break;
        case "enter":
          if (this.selectedHotspot.introEnd <= this.$refs.video.currentTime) {
            this.setStatus("wait");
          }
          break;
        case "wait":
          this.$refs.video.pause();
          break;
        case "leave":
          if (this.selectedHotspot.outroEnd <= this.$refs.video.currentTime) {
            this.reset();
          }
          break;
        default:
          break;
      }
    }
  },
  watch: {
    status(newValue, oldValue) {
      // console.log(`Updating from ${oldValue} to ${newValue}`);

      switch (newValue) {
        case "idle":
          this.$refs.video.pause();
          break;
        case "enter":
          this.$refs.video.currentTime = this.selectedHotspot.introStart;
          this.$refs.video.play();
          break;
        case "wait":
          this.$refs.video.pause();
          break;
        case "leave":
          this.$refs.video.currentTime = this.selectedHotspot.outroStart;
          this.$refs.video.play();
          break;
        default:
          break;
      }
    }
  }
};
</script>
